<script>
  import servico from '../servico';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';

  export default {
    components: { AdicionarArquivos },
    data() {
      return {
        solicitacao: null,
        prestacao: null,
        arquivos: [],
        carregando: true,
        carregandoArquivos: true,
        descricaoAtividade: '',
        reenviando: false,
        configuracao: this.$storage.configuracao(),
      }
    },
    computed: {
      aceita() {
        return !!(this.prestacao && this.prestacao.dataHoraAceitoPrestConta);
      },
      rejeitada() {
        return !!(this.prestacao && !this.prestacao.dataHoraAceitoPrestConta && this.prestacao.motivoRejeicao);
      },
      enviada() {
        return !!(this.prestacao && this.prestacao.dataHoraAtividade && !this.rejeitada);
      },
      somenteLeitura() {
        return this.enviada && !this.reenviando;
      },
      prazoVencido() {
        if (!this.prestacao || !this.prestacao.dataLimitePrestacao || this.aceita) {
          return false;
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        return new Date(this.prestacao.dataLimitePrestacao) < hoje;
      },
    },
    created() {
      this.carregar(this.$route.params.idCript);
    },
    mounted() {
      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      carregar(id) {
        this.carregando = true;

        servico.obterPorId(id)
          .then(dados => {
            this.solicitacao = dados;
            this.$root.tituloDaPagina = 'Prestação de contas - Solicitação #' + dados.idSolicitacaoReembolso;
            this.carregando = false;
          });

        this.carregarPrestacao(id);
        this.carregarArquivos(id);
      },
      carregarPrestacao(id) {
        return servico.prestacao(id)
          .then(dados => {
            this.prestacao = dados;
            this.descricaoAtividade = dados.descricaoAtividade || '';
          });
      },
      carregarArquivos(id) {
        this.carregandoArquivos = true;

        return servico.arquivos(id)
          .then(arquivos => {
            this.arquivos = arquivos;
            this.carregandoArquivos = false;
          })
          .catch(() => {
            this.arquivos = [];
            this.carregandoArquivos = false;
          });
      },
      nomeArquivo(arquivo) {
        return arquivo.split('/').pop().split('\\').pop();
      },
      baixar(arquivo) {
        return servico.download(this.$route.params.idCript, this.nomeArquivo(arquivo))
          .catch(() => toastr.error('Ocorreu um erro ao baixar o arquivo.'));
      },
      tipo(tipoReembolso) {
        if (tipoReembolso === 0) {
          return 'Passagem';
        }
        if (tipoReembolso === 1) {
          return 'Diária';
        }
        return 'Adiantamento';
      },
      reenviar() {
        this.reenviando = true;
        this.$nextTick(() => $('#tabs a[href="#tab-descricao-atividade"]').tab('show'));
      },
      salvar() {
        $('#salvar').button('loading');

        this.$validator.validateAll()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-descricao-atividade"]').tab('show');
            }
            return valido;
          })
          .then(this.enviar)
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao registrar a prestação de contas.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        var arquivos = this.$refs.adicionarArquivos.arquivos;

        if (!this.$refs.adicionarArquivos.existeArquivo()) {
          $('#salvar').button('reset');
          $('#tabs a[href="#tab-adicionar-arquivos"]').tab('show');
          toastr.warning('É obrigatório anexar pelo menos um arquivo na prestação de contas.');

          return;
        }

        var id = this.$route.params.idCript;
        var formData = new FormData();
        formData.append('descricaoAtividade', this.descricaoAtividade);

        for (var i = 0; i < arquivos.length; i++) {
          if (arquivos[i]) {
            formData.append('arquivos', arquivos[i]);
          }
        }

        return servico.salvarAtividade(id, formData)
          .then(() => {
            toastr.success('Prestação de contas registrada com sucesso.');
            this.$router.push({
              name: 'solicitacao-reembolso-pf-atividade',
              params: { filtrosBag: this.$route.params.filtrosBag },
            });
          });
      },
    },
  }
</script>

<style scoped>
  .table .action {
    width: 1%;
    white-space: nowrap;
    text-align: center;
  }
</style>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <div class="row">
      <div class="col-xs-12">
        <div class="ibox float-e-margins" v-if="carregando">
          <div class="ibox-content">
            <p class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>
          </div>
        </div>

        <div v-show="!carregando">

          <div class="alert alert-danger" v-if="prazoVencido">
            <i class="fa fa-exclamation-triangle"></i>
            O prazo para prestação de contas venceu em
            {{ prestacao.dataLimitePrestacao | formatarData }}.
            Entre em contato com a instituição.
          </div>

          <div class="alert alert-danger" v-if="rejeitada">
            <i class="fa fa-times-circle"></i>
            <strong>Prestação de contas rejeitada</strong>
            <span v-if="prestacao.conferidoPor"> por {{ prestacao.conferidoPor }}</span>.
            <br>
            Motivo: {{ prestacao.motivoRejeicao }}
          </div>

          <div class="alert alert-success" v-if="aceita">
            <i class="fa fa-check-circle-o"></i>
            Prestação de contas aceita em {{ prestacao.dataHoraAceitoPrestConta | formatarData }}
            <span v-if="prestacao.conferidoPor"> por {{ prestacao.conferidoPor }}</span>.
          </div>

          <div class="alert alert-info" v-if="enviada && !aceita && !reenviando">
            <i class="fa fa-clock-o"></i>
            Prestação de contas enviada em {{ prestacao.dataHoraAtividade | formatarData }} -
            {{ prestacao.dataHoraAtividade | formatarHora }}
            <span v-if="prestacao.prestadoPor"> por {{ prestacao.prestadoPor }}</span>.
            Aguardando conferência.
          </div>

          <div class="tabs-container" id="tabs">

            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-solicitacao">
                  Dados da solicitação
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-descricao-atividade">
                  Descrição da atividade
                </a>
              </li>
              <li>
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  {{ somenteLeitura ? 'Arquivos' : 'Adicionar arquivos' }}
                </a>
              </li>
            </ul>

            <div class="tab-content">

              <div id="tab-dados-solicitacao" class="tab-pane active">
                <div class="panel-body" v-if="solicitacao">
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Número</label>
                        <input type="text" class="form-control" :value="solicitacao.idSolicitacaoReembolso" disabled>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Tipo</label>
                        <input type="text" class="form-control" :value="tipo(solicitacao.tipoReembolso)" disabled>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Data solicitação</label>
                        <input type="text" class="form-control" :value="$options.filters.formatarNumeroEmData(solicitacao.dataSolicitacao)" disabled>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="form-group">
                        <label>Prazo prestação de contas</label>
                        <input type="text"
                               class="form-control"
                               :class="{'text-danger': prazoVencido}"
                               :value="prestacao && prestacao.dataLimitePrestacao ? $options.filters.formatarData(prestacao.dataLimitePrestacao) : '---'"
                               disabled>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Beneficiário</label>
                        <input type="text" class="form-control" :value="solicitacao.documentoTerceiro + ' - ' + solicitacao.nomeTerceiro" disabled>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Projeto</label>
                        <input type="text" class="form-control" :value="solicitacao.projeto ? solicitacao.projeto.nomeProjeto : ''" disabled>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label>Observação</label>
                        <textarea class="form-control" rows="3" :value="solicitacao.observacao" disabled></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tab-descricao-atividade" class="tab-pane">
                <div class="panel-body">
                  <div class="form-group" v-if="somenteLeitura">
                    <label class="control-label">Descrição da atividade</label>
                    <textarea class="form-control"
                              rows="5"
                              :value="prestacao ? prestacao.descricaoAtividade : ''"
                              disabled></textarea>
                  </div>

                  <div class="form-group required"
                       v-if="!somenteLeitura"
                       :class="{'has-error': errors.has('descricaoAtividade')}">
                    <label class="control-label">Descrição da atividade</label>
                    <textarea class="form-control"
                              rows="5"
                              v-model="descricaoAtividade"
                              placeholder="Descreva a atividade realizada"
                              data-vv-name="descricaoAtividade"
                              data-vv-as="descrição da atividade"
                              v-validate="'required'"></textarea>
                    <p class="text-danger" v-show="errors.has('descricaoAtividade')">
                      {{ errors.first('descricaoAtividade') }}
                    </p>
                  </div>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">

                  <div class="form-group">
                    <label class="control-label">Arquivos enviados</label>

                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Nome do arquivo</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(arquivo, indice) in arquivos">
                            <td>{{ nomeArquivo(arquivo) }}</td>
                            <td class="action">
                              <button type="button"
                                      class="btn btn-default btn-xs"
                                      v-tooltip="'Baixar arquivo'"
                                      @click="baixar(arquivo)">
                                <i class="fa fa-download"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="!arquivos.length && !carregandoArquivos">
                            <td colspan="2" class="text-center">Nenhum arquivo enviado.</td>
                          </tr>
                          <tr v-show="carregandoArquivos">
                            <td colspan="2">
                              <i class='fa fa-spinner fa-pulse'></i> Carregando...
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="form-group required" v-if="!somenteLeitura">
                    <label class="control-label">Anexar arquivos</label>
                    <adicionar-arquivos ref="adicionarArquivos"></adicionar-arquivos>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <router-link class="btn btn-default"
              :to="{ name: 'solicitacao-reembolso-pf-atividade', params: { filtrosBag: $route.params.filtrosBag } }"
             active-class="">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>

          <button id="salvar" type="button" class="btn btn-primary"
              @click="salvar" v-show="!carregando && !somenteLeitura"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
            <i class="fa fa-save"></i> {{ rejeitada ? 'Reenviar' : 'Salvar' }}
          </button>

          <button type="button" class="btn btn-warning"
              @click="reenviar" v-show="!carregando && somenteLeitura && !aceita">
            <i class="fa fa-refresh"></i> Enviar nova prestação
          </button>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-atividade/componentes/SolicitacaoReembolsoAtividadeForm.vue